module.exports = __webpack_public_path__ + "media/src/images/signUpBtn-3e12d91afa66dfa160a33b17b5c13217.png";